import React from 'react';
import { useAuth } from '../context/AuthContext';

export const Admin = () => {
  const { user } = useAuth();

  return (
    <div style={{ maxWidth: 1100, margin: '40px auto', padding: '0 20px' }}>
      <h1>Administrator paneli</h1>
      <p>Xush kelibsiz, <strong>{user?.first_name || user?.username}</strong>!</p>
    </div>
  );
};
